<template>
  <PageTemplate title="Admin Log" v-if="isAdmin">
    <div class="flex flex-row space-x-4 pb-4 items-center">
      <!-- {{ lineData }}
    <br />
    {{ lineSegmentsData }} -->
      <!-- {{ lineSegmentsDataCost }} -->

      <SelectMenu
        class="w-40"
        label="Time range"
        v-model="activeTimeFilter"
        :options="timeFilters"
      />

      <SelectMenu
        class="w-40"
        label="Success"
        v-model="activeSuccessFilter"
        :options="successFilters"
      />

      <!-- <SelectMenu
      class="w-40"
      label="Check"
      v-model="activeCheckFilter"
      :options="checkFilters"
    /> -->

      <div>
        <label
          for="keyword"
          class="block text-sm font-medium leading-6 text-gray-900 dark:text-white"
          >Keyword</label
        >
        <input
          v-model="keywordFilter"
          id="keyword"
          class="block dark:bg-transparent dark:text-white w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary text-sm sm:leading-6"
          autocomplete="off"
        />
      </div>

      <!-- <div class="flex flex-row space-x-4 pb-4 items-center"> -->
      <div class="grow flex justify-end items-center gap-x-1.5">
        <Spinner v-if="loadingLog" class="h-min w-min" />
        <button
          @click="
            fetchLog()
            // fetchStats();
          "
          class="flex gap-x-1.5 rounded-md bg-white dark:bg-slate-800 dark:text-gray-100 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-slate-700"
        >
          <ArrowPathIcon class="h-5 w-5" aria-hidden="true" />
          <span> Refresh </span>
        </button>
      </div>
      <!-- </div> -->
    </div>

    <Card
      v-if="!loadingLog && _.isEmpty(logData)"
      class="text-sm text-gray-500"
    >
      <div>No logs in the selected time range.</div>
    </Card>

    <div v-if="!_.isEmpty(logData)">
      <Table
        title="Requests"
        :data="logData"
        :dense="true"
        :loading="loadingLog"
        :num-columns-bold="0"
        :pagination="true"
        :pagination-settings="{
          total: total,
          page: page,
          size: pageSize,
          pages: pages,
        }"
        @select-page="page = $event"
      >
      </Table>
    </div>
  </PageTemplate>
</template>
<script setup lang="ts">
import { ref, computed, watch, type Ref } from "vue";
import Table from "@/components/Table.vue";
import {
  DefaultService as api,
  type ResearchResponse,
  // type PromptExecution,
  // type TestCaseDataset,
} from "../client";
import _ from "lodash";
import "chartjs-adapter-date-fns";
import Card from "@/components/Card.vue";
import { useStore } from "@/store";
import { notifyNegative, notifyPositive, openDocs } from "@/helperfunctions";
import SelectMenu from "@/components/utils/SelectMenu.vue";
import { ArrowPathIcon } from "@heroicons/vue/24/outline";
import Spinner from "@/components/utils/Spinner.vue";
import PageTemplate from "./PageTemplate.vue";
import { useUser } from "@clerk/vue";

const store = useStore();

const { user } = useUser();
const isAdmin = computed(() => user.value?.publicMetadata?.admin === true);

const logData: Ref<ResearchResponse[]> = ref([]);

const timeFilters = [
  "1 hour",
  "24 hours",
  "7 days",
  // "14 days",
  // "30 days",
  // "12 weeks",
];
const activeTimeFilter = ref("24 hours");

const successFilters = [
  { label: "All", value: "All" },
  { label: "Success", value: true },
  { label: "Failed", value: false },
];
const activeSuccessFilter = ref("All");

// const checkFilters = [
//   { label: "All", value: "All" },
//   { label: "Hallucination", value: "hallucination" },
//   { label: "Prompt Injection", value: "prompt_injection" },
//   { label: "PII", value: "pii" },
//   { label: "Classification", value: "classification" },
// ];
// const activeCheckFilter = ref("All");

const keywordFilter = ref("");

const loadingLog = ref(true);

const activeFilters = computed(() => {
  return {
    time_created: activeTimeFilter.value,
    // passed: activeResultFilter.value.value || activeResultFilter.value,
    // check_name: activeCheckFilter.value.value || activeCheckFilter.value,
    success: activeSuccessFilter.value.value,
    keyword: keywordFilter.value,
  };
});

const page = ref(1);
const pageSize = ref(100);
const total = ref(0);
const pages = ref(1);

function fetchLog() {
  loadingLog.value = true;

  return api
    .getAdminResearchResponsesPaginate(
      activeFilters.value,
      page.value,
      pageSize.value
    )
    .then((res) => {
      // console.log(res);

      total.value = res.total;
      pages.value = res.pages;

      logData.value = res.items.map((r) => {
        let check_dict = {};
        check_dict[r.check_name] = r.result_details;
        let res = {
          // id: r.id,
          time_time: r.time_created,
          task: r.request.task,
          "Query/URL": r.request.query || r.request.url,
          // depth: r.request.depth,
          // depth: {
          //   displayAs: "tag",
          //   value: r.request.depth,
          // },
          // answer_format: r.request.answer_format,
          success: r.success,
          credits: r.credits,
          // time: r.times,
        };

        if (!_.isEmpty(r.times)) res = { ...res, ...r.times };

        return res;
      });

      // sort by time
      // logData.value.sort((a, b) => {
      //   return new Date(b.time_time) - new Date(a.time_time);
      // });
    })
    .catch((err) => {
      console.log(err);
      notifyNegative("Failed to fetch log data");
    })
    .finally(() => {
      loadingLog.value = false;
    });
}

fetchLog();

watch(
  () => page.value,
  () => {
    console.log("fetching log");
    fetchLog();
  }
);

const statsData = ref([]);

// function fetchStats() {
//   api
//     .getCheckResultStats(activeFilters.value)
//     .then((res) => {
//       statsData.value = res;
//     })
//     .catch((err) => {
//       console.log(err);
//       notifyNegative("Failed to fetch statistics");
//     });
// }

// fetchStats();

const metricsToKepp = ["completion_tokens", "first_chunk", "full_request"];

const timeRangeStart = computed(() => {
  // subtract activeTimeFilter (1 hour, 24 hours, etc. from now)
  switch (activeTimeFilter.value) {
    case "1 hour":
      return new Date(Date.now() - 60 * 60 * 1000);
    case "24 hours":
      return new Date(Date.now() - 24 * 60 * 60 * 1000);
    case "7 days":
      return new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    case "14 days":
      return new Date(Date.now() - 14 * 24 * 60 * 60 * 1000);
    case "30 days":
      return new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
    case "12 weeks":
      return new Date(Date.now() - 12 * 7 * 24 * 60 * 60 * 1000);
  }
});

const percentageFormatter = Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1,
});

watch(
  () => (
    activeTimeFilter.value,
    // activeResultFilter.value,
    // activeCheckFilter.value,
    activeSuccessFilter.value,
    keywordFilter.value
  ),
  () => {
    if (!loadingLog.value) {
      fetchLog();
      // fetchStats();
    }
  },
  { deep: true }
);

// function viewCheckResult(row) {
//   store.displayLog(row.id);
// }

const credits = ref();
</script>
